import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// This controller detects when the Turbo Stream source is connected or disconnected, and refreshes the page on reconnect
export default class extends Controller {
  wasConnected = false;

  connect() {
    this.wasConnected = this.isConnected;

    const observer = new MutationObserver((records, observer) => {
      const record = records[0];
      if (this.isConnected) {
        if (record.oldValue === null && this.wasConnected) {
          Turbo.session.refresh(location.href);
        }
        this.wasConnected = true;
      }
    });

    observer.observe(this.element, { attributeFilter: ["connected"], attributeOldValue: true });
  }

  get isConnected() {
    return this.element.hasAttribute("connected");
  }
}
